import { NgModule } from '@angular/core';
import { ExpenseCategoryService } from './expense-category.service';
import { ExpenseCategoryBackend } from './expense-category.backend';

@NgModule({
  providers: [ExpenseCategoryService, ExpenseCategoryBackend],
})
export class ExpenseCategoryModule {}
